import React from 'react';
export function Footer() {
  return <footer className="max-w-3xl mx-auto text-center py-16 px-4" data-id="element-190">
      <div className="text-[#00C853] text-2xl font-black tracking-widest mb-4" data-id="element-191">
        🇮🇹 PROFEPACK™
      </div>
      <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-192">
        El sistema de enseñanza N°1 para docentes de Italiano en institutos de
        idiomas y escuelas de todo el mundo.
      </p>
      <p className="text-gray-400 text-sm italic mb-6 font-bold" data-id="element-193">
        Porque enseñar Italiano no debería costarte todos los fines de semana
        del año.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-194">
        <span data-id="element-195">📧 support@profepack.com</span>
        <span className="hidden sm:inline" data-id="element-196">•</span>
        <span data-id="element-197">📲 @edulabs.oficial</span>
        <span className="hidden sm:inline" data-id="element-198">•</span>
        <span data-id="element-199">🌐 www.edualabs.online</span>
      </div>

      <div className="h-px bg-[#00C853]/20 mb-6" data-id="element-200" />
      <p className="text-gray-400 text-xs mb-2" data-id="element-201">
        © EDULABS™ 2026 — Todos los derechos reservados.
      </p>
      <p className="text-gray-500 text-xs mb-6" data-id="element-202">
        Prohibida la reproducción y redistribución sin autorización expresa.
      </p>
      <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-203">
        🇮🇹 "Il prossimo domenico può essere diverso."
        <br data-id="element-204" />
        "El próximo domingo puede ser diferente."
      </p>
    </footer>;
}